// Libraries
import { m } from "framer-motion";
import { Col, Container, Row } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";

// Animation
import { fadeIn } from "@/Functions/GlobalAnimations";

export const ProductsAndStacks = (props) => {
  const { t } = useTranslation();
  return (
    <section className="pt-[200px] xs:pt-[100px]">
      <Container fluid>
        <Row className="  px-[100px] sm:px-[50px]">
          <h5 className="font-semibold text-center font-serif uppercase mb-[20px] tracking-[1px] block sm:mb-[20px]">
            {t("page.main.stack.AI_products.title")}
          </h5>
          <Col className="font-serif uppercase leading-[12px] mt-[50px] mb-[150px]">
            <Row>
              <m.div
                {...fadeIn}
                transition={{ delay: 0.5 }}
                className="col-12 col-md-4 col-sm-12 text-center border-r font-medium uppercase text-sm leading-[12px] border-red-500 sm:border-none sm:mb-[30px] sm:text-lg"
              >
                <span className="inline-block md:mb-[10px] md:block font-serif">
                  {t("page.main.stack.AI_products.products.0")}
                </span>
              </m.div>
              <m.div
                {...fadeIn}
                transition={{ delay: 0.6 }}
                className="col-12 col-md-4 col-sm-12 text-center border-r font-medium uppercase text-sm leading-[12px] border-red-500 sm:border-none sm:mb-[30px] sm:text-lg"
              >
                <span className="inline-block md:mb-[10px] md:block font-serif">
                  {t("page.main.stack.AI_products.products.1")}
                </span>
              </m.div>
              <m.div
                {...fadeIn}
                transition={{ delay: 0.7 }}
                className="col-12 col-md-4 col-sm-12 text-center font-medium uppercase text-sm leading-[12px] sm:text-lg"
              >
                <span className="inline-block md:mb-[10px] font-serif md:block">
                  {t("page.main.stack.AI_products.products.2")}
                </span>
              </m.div>
            </Row>
          </Col>
          {/* ВРЕМЕННО ЗАКОММЕНТИРОВАНО */}
          {/* <Col>
            <Row>
              <h5 className="font-semibold text-primary-main mt-[80px] font-serif uppercase mb-[20px] tracking-[1px] block sm:mb-[20px]">
                {t("page.main.stack.stack_technologies.title")}
              </h5>
              <ol className="text-lg font-serif my-[30px] tracking-[1px] block sm:mb-[20px] leading-8">
                <li className="mb-[10px] ">
                  <h5 className="text-[25px] my-[30px] uppercase">
                    {t(
                      "page.main.stack.stack_technologies.technologies.0.title"
                    )}
                  </h5>
                  <p>
                    {t(
                      "page.main.stack.stack_technologies.technologies.0.description"
                    )}
                  </p>
                </li>
                <li className="mb-[10px]">
                  <h5 className="text-[25px] my-[30px] uppercase">
                    {t(
                      "page.main.stack.stack_technologies.technologies.1.title"
                    )}
                  </h5>
                  <p>
                    <Trans
                      i18nKey="page.main.stack.stack_technologies.technologies.1.description"
                      components={{
                        br: (
                          <>
                            <br />
                            <br />
                          </>
                        ),
                      }}
                    />
                  </p>
                </li>
                <li className="mb-[10px]">
                  <h5 className="text-[25px] my-[30px] uppercase">
                    {t(
                      "page.main.stack.stack_technologies.technologies.2.title"
                    )}
                  </h5>
                  <p>
                    {t(
                      "page.main.stack.stack_technologies.technologies.2.description"
                    )}
                  </p>
                </li>
              </ol>
            </Row>
          </Col> */}
        </Row>
      </Container>
    </section>
  );
};
